<template>
  <div class="intro-push-container">
    <common-header></common-header>
    <div class="header-banner"></div>
    <!-- 播放器价值 -->
    <common-advantage :advantages="valuesList"></common-advantage>
    <!-- 播放器优势 -->
    <common-advantage :advantages="advantageList"></common-advantage>
    <!-- 播放器功能介绍 -->
    <common-advantage :advantages="functionList"></common-advantage>
    <!-- 播放器架构图 -->
    <div class="application-wrap resolution-wrap">
      <common-application title="播放器架构图" :tabcontent="tabcontent"></common-application>
    </div>
    <!-- 播放器应用案例 -->
    <div class="application-wrap appcase-wrap">
      <common-application title="播放器应用案例" :tabcontent="tabcontent2"></common-application>
    </div>
    <common-footer></common-footer>
  </div>
</template>
<script>
import mainHeader from '@/components/mainheader'
import mainFooter from '@/components/mainfooter'
import advantage from '@/components/advantage'
import application from '@/components/application'
export default {
  name: 'app',
  components: {
    'common-header': mainHeader,
    'common-footer': mainFooter,
    'common-advantage': advantage,
    'common-application': application
  },
  data () {
    return {
      tabcontent: ['player-banner2'],
      tabcontent2: ['player-banner3'],
      currentTabIndex: 0,
      currentTabIndex2: 0,
      hoverIndex: -1,
      valuesList: {
        title: '播放器价值',
        mulitrow: false,
        list: [
          {
            key: '0',
            title: '超低的开发成本',
            desc: '提供单一SDK免除集成接入的繁杂过程，提供简化易用的通用API，开发者只需要关注上层业务的逻辑实现',
            iconname: 'icon-player-01'
          },
          {
            key: '1',
            title: '超低的维护成本',
            desc: '汽车之家的主App已在使用，通过实际用户基数，可以有效的保证稳定性和质量始终保持在高水准之上，减少使用大量的兼容性开发及测试成本',
            iconname: 'icon-player-02'
          },
          {
            key: '2',
            title: '高效的性能和用户体验',
            desc: '支持硬件解码最大限度的利用本地机能，同时内置高效的预加载算法最大程度的保证用户体验',
            iconname: 'icon-player-03'
          }
        ]
      },
      advantageList: {
        title: '播放器优势',
        mulitrow: true,
        list: [
          {
            key: '0',
            title: '轻量级集成，开发成本，本地/远程视频播放，直播拉流一体化SDK方案',
            desc: '轻松快速上手，可以在3小时内完成接入，半天完成工程集成',
            iconname: 'icon-player-04'
          },
          {
            key: '1',
            title: '多种主流视频解码，并支持硬解码',
            desc: '达到业界一流的解码性能，最大化的利用本地硬件性能，实现视频完美的流畅播放，网络性能的极具优化，降低网络延迟带来的用户感知',
            iconname: 'icon-player-05'
          },
          {
            key: '2',
            title: '低的接入使用成本和学习成本，自带一套UI方案，并且自由定制',
            desc: '丰富的示例代码，用户可以自由灵活的根据需求进行定制修改',
            iconname: 'icon-player-06'
          },
          {
            key: '3',
            title: '内置预加载模块，可以实现即点即开的畅快体验',
            desc: '预加载方案媲美本地视频播放体验的网络加载优化',
            iconname: 'icon-player-07'
          }
        ]
      },
      functionList: {
        title: '播放器功能介绍',
        mulitrow: true,
        list: [
          {
            key: '0',
            title: '本地视频播放',
            desc: '主流多种视频格式本地视频、远程视频文件（HLS）播放，支持（软/硬）解码',
            iconname: 'icon-player-08'
          },
          {
            key: '1',
            title: '直播拉流播放',
            desc: '支持主流的直播协议，高效首桢高效载入算法，实现直播直播的低延迟，高响应。',
            iconname: 'icon-player-09'
          },
          {
            key: '2',
            title: '视频预加载',
            desc: '高效通过预加载算法，实现视频快速载入',
            iconname: 'icon-player-10'
          },
          {
            key: '3',
            title: '实时丰富的调试信息支持',
            desc: '开发人员可在debug模式查看视频详细信息',
            iconname: 'icon-player-11'
          },
          {
            key: '4',
            title: '视频倍速播放',
            desc: '0.7到2.0的实时倍速播放',
            iconname: 'icon-player-12'
          }
        ]
      }
    }
  },
  created(){
    // pv上报
    // 埋点
    window.pvTrack = {
      site: 144,
      category: 1721,
    }
    window.trackPageView()
  },
  methods: {}
}
</script>

<style scoped>
.intro-push-container {
  background-color: #F7F9FA;
}
.header-banner {
  width: 100%;
  height: 542px;
  background-size: cover;
  background-image: url('./../assets/images/index-banner_player.png');
  background-repeat: no-repeat;
  background-position: -2px 0;
  position: relative;
  top: -1px;
}
.application-wrap {
  margin-bottom: -2px;
}
.resolution-wrap {
  padding-top: 10px;
  background: #333B5B;
  margin-top: 50px;
}
.appcase-wrap {
  padding-top: 10px;
  background: #333B5B;
  margin-top: 0;
}
.intro-zhibo-container .application-title .line i {
  background: rgba(202,206,213,.5);
}
</style>



// WEBPACK FOOTER //
// src/view/intro_player.vue